/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SyncCustomersWithGetLagoResult } from '../../models/sync-customers-with-get-lago-result';

export interface ApiAdminSyncCustomersPost$Params {
  force?: boolean;
}

export function apiAdminSyncCustomersPost(http: HttpClient, rootUrl: string, params?: ApiAdminSyncCustomersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SyncCustomersWithGetLagoResult>> {
  const rb = new RequestBuilder(rootUrl, apiAdminSyncCustomersPost.PATH, 'post');
  if (params) {
    rb.query('force', params.force, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SyncCustomersWithGetLagoResult>;
    })
  );
}

apiAdminSyncCustomersPost.PATH = '/api/Admin/sync-customers';
